import uiDataSelector from './ui_data_selector'
import uiParamsSelector from './ui_params_selector'

export default {
	uiDataSelector,
	uiParamsSelector,
}
